import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { roundTo } from '../../../utils/geometry/epsilon';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import TabComponent from '../../../components/common/TabComponent/TabComponent';
import ButtonSecondaryLarge from '../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import { Icon } from '../../../components/icon/icon';
import { Collapse, Table } from 'antd';
import { Menu } from 'antd';
import { Empty } from 'antd';
import ButtonIconOutlineMedium from '../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';

const SectionDetail = ({ data }) => {
  const { t } = useTranslation();

  const [activeMenuKey, setActiveMenuKey] = useState('0');
  const [activedKey, setActivedKey] = useState(1);
  const [items, setItems] = useState([]);

  const columns = [
    {
      title: t('Product'),
      dataIndex: 'thumbnail_url',
      key: 'thumbnail_url',
      width: 112,
      render: value => {
        return (
          <div className="flex py-10 px-16 justify-center items-center gap-10 self-stretch">
            <img
              src={value}
              alt=""
              className="w-60 h-60 fex-shrink-0 rounded-[2px]"
            />
          </div>
        );
      },
    },
    {
      title: t('Information'),
      dataIndex: 'info',
      key: 'info',
      render: (_, record) => {
        return (
          <div className="flex p-16 ps-24 justify-center items-start gap-8 self-stretch grow flex-col">
            <span className="text-title-medium">
              {t(getValueFromString(record.name))}
            </span>
            <div className="flex flex-col items-start gap-4 self-stretch">
              {record.material ? (
                <div className="flex items-start gap-8 self-stretch">
                  <span
                    className="text-body-medium"
                    style={{ color: '#818589' }}
                  >
                    {t('Material')}
                  </span>
                  <span className="text-body-medium">{t(record.material)}</span>
                </div>
              ) : (
                <></>
              )}

              {record.texture || record.paintColor ? (
                <div className="flex items-start gap-8 self-stretch">
                  <span
                    className="text-body-medium"
                    style={{ color: '#818589' }}
                  >
                    {t('Color')}
                  </span>
                  <span className="text-body-medium">
                    {record.texture ?? record.paintColor ?? '--'}
                  </span>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: t('Size'),
      dataIndex: 'size',
      key: 'size',
      width: 180,
      render: value => {
        if (value) {
          let result;
          if (value.x) {
            result = roundTo((value.x ?? 0) * 1000, 0);
          }
          if (value.y) {
            if (result) {
              result = result + ' x ';
            } else {
              result = '';
            }
            result = result + roundTo((value.y ?? 0) * 1000, 0);
          }
          if (value.z) {
            if (result) {
              result = result + ' x ';
            } else {
              result = '';
            }
            result = result + roundTo((value.z ?? 0) * 1000, 0);
          }
          return (
            <div className="flex p-16 ps-24 justify-center items-start gap-8 self-stretch grow flex-col">
              <span className="text-body-medium">{result} mm</span>
            </div>
          );
          return <></>;
        }
      },
    },
    {
      title: t('Quantity'),
      dataIndex: 'count',
      key: 'count',
      width: 120,
      render: value => {
        return (
          <div className="flex p-16 ps-24 justify-center items-start gap-8 self-stretch grow flex-col">
            <span className="text-body-medium">x{value}</span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    let tempItems = [];
    if (Array.isArray(data.items)) {
      tempItems = data.items.map(item => [item.name, item.data ?? []]);
    } else {
      tempItems = Object.entries(data?.items ?? {}).map(([key, value]) => [
        key,
        value ?? [],
      ]);
    }
    setItems(tempItems);
  }, [data]);
  // const items = ;

  return (
    <>
      <div className="lg:flex hidden flex-col items-start lg:py-[32px] lg:px-[80px] py-[32px] md:px-[20px] px-[16px] gap-[16px] bg-fills-white overflow-hidden">
        <TabComponent
          defaultActiveKey={activedKey}
          items={[
            {
              key: 1,
              label: t('Product details'),
              children: Object.entries(data?.items ?? {}).length ? (
                <div className="w-full relative flex lg:p-[32px] p-[16px] max-h-[772px] items-start self-stretch grow rounded-[8px] bg-fills-primary-varient">
                  <div className="flex items-start grow self-stretch overflow-hidden relative">
                    <div className="flex min-w-[200px]">
                      <Menu
                        className={
                          'flex flex-col items-start gap-8 bg-transparent !border-none text-black-medium [&_.ant-menu-item-selected]:bg-primary-primaryVarient1 [&_.ant-menu-item-selected]:text-white-high [&_.ant-menu-item-selected_.ant-menu-title-content_.text-body-medium]:font-semibold '
                        }
                        onClick={e => {
                          setActiveMenuKey(e.key);
                        }}
                        defaultSelectedKeys={activeMenuKey?.toString()}
                        items={[
                          ...items
                            .map(([key], index) => ({
                              key: index.toString(),
                              label: (
                                <span className="text-body-medium">
                                  {t(key)}
                                </span>
                              ),
                            }))
                            .sort(
                              (a, b) =>
                                !a.name?.localeCompare(b.name, 'vi', {
                                  sensitivity: 'base',
                                })
                            ),
                        ]}
                      />
                    </div>

                    <div
                      className="flex self-stretch grow bg-white h-[653px] rounded-[8px] w-full"
                      // style={{ height: "100%", overflow: "auto" }}
                    >
                      <Table
                        dataSource={items
                          .filter(
                            (_, index) => index.toString() === activeMenuKey
                          )
                          .map(([key, value]) => {
                            if (
                              ['countertop', 'backsplash'].some(item =>
                                key.toLowerCase().includes(item)
                              )
                            ) {
                              const items =
                                data?.['meta_data']?.price?.[key.toLowerCase()];
                              const temp = value.map((item, index) => ({
                                ...item,
                                size: {
                                  x: items?.[index]?.length ?? 0,
                                },
                              }));
                              return temp;
                            } else return value;
                          })
                          .flat()
                          .reduce((prev, curr) => {
                            const index = prev.findIndex(item => {
                              return (
                                JSON.stringify({
                                  ...item,
                                  size: {
                                    x: roundTo(item.size?.x ?? 0),
                                    y: roundTo(item.size?.y ?? 0),
                                    z: roundTo(item.size?.z ?? 0),
                                  },
                                  count: 0,
                                }) ===
                                JSON.stringify({
                                  ...curr,
                                  size: {
                                    x: roundTo(curr.size?.x ?? 0),
                                    y: roundTo(curr.size?.y ?? 0),
                                    z: roundTo(curr.size?.z ?? 0),
                                  },
                                  count: 0,
                                })
                              );
                            });
                            if (index >= 0) {
                              const arr = [...prev];
                              arr[index] = {
                                ...arr[index],
                                count: arr[index].count + curr.count,
                              };
                              return arr;
                            }
                            return [...prev, curr];
                          }, [])
                          .sort(
                            (a, b) =>
                              !a.name?.localeCompare(b.name, 'vi', {
                                sensitivity: 'base',
                              })
                          )}
                        columns={columns}
                        className="[&_.ant-table-thead_tr_th]:!bg-fills-primary-varient [&_.ant-table-body_tr_td:first-child]:!border-none"
                        pagination={false}
                        scroll={{ y: 640 }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <Empty />
              ),
            },
            {
              key: 2,
              label: t('Warranty & Maintenance'),
              children: (
                // <div
                //   className="w-full relative flex p-24 flex-col items-start gap-32 grow self-stretch"
                //   style={{ height: "770px" }}>
                //   <span className="text-body-medium">
                //   </span>
                // </div>
                <Empty />
              ),
            },
            {
              key: 3,
              label: t('Installation Guide'),
              children: (
                <div
                  className="flex relative w-full p-24 flex-col items-end gap-16 grow self-stretch rounded-[8px]"
                  style={{
                    background: '#FAFBFB',
                    height: '770px',
                    overflow: 'auto',
                  }}
                >
                  <ButtonSecondaryLarge
                    posIcon={<Icon.ICDownload />}
                    title={t('Download full PDF')}
                  />
                  <div className="flex flex-col items-start gap-16 grow self-stretch">
                    <Collapse
                      expandIcon={({ isActive }) => (
                        <span className="w-16 h-16 flex">
                          {isActive ? (
                            <Icon.ICExpandMore />
                          ) : (
                            <Icon.ICExpandLess />
                          )}
                        </span>
                      )}
                      defaultActiveKey={['1']}
                      className="self-stretch overflow-auto"
                      items={[
                        {
                          key: '1',
                          label: (
                            <span className="text-title-large py-12 px-8 flex">
                              {t(
                                'Installation Guide for Lower Kitchen Cabinet'
                              )}
                            </span>
                          ),
                          children: (
                            <div
                              className="flex p-16 items-start gap-40 self-stretch"
                              style={{ height: '308px' }}
                            >
                              <ul className="grow text-body-medium">
                                <li>
                                  Dùng cờ lê đi kèm để tháo các ốc giữ lồng giặt
                                  ở phía sau máy.
                                </li>
                                <li>
                                  Lắp các miếng đệm cao su vào vị trí các ốc đã
                                  tháo để tránh côn trùng, bụi bẩn vào bên trong
                                  máy.
                                </li>
                              </ul>
                              <div
                                style={{
                                  width: '491px',
                                  height: '276px',
                                  aspectRatio: '153/86',
                                }}
                              >
                                <img src="" alt="" />
                              </div>
                            </div>
                          ),
                        },
                        {
                          key: '2',
                          label: (
                            <span className="text-title-large py-12 px-8 flex">
                              {t(
                                'Installation Guide for Corner Lower Kitchen Cabinet'
                              )}
                            </span>
                          ),
                          children: (
                            <div
                              className="flex p-16 items-start gap-40 self-stretch"
                              style={{ height: '308px' }}
                            >
                              <ul className="grow text-body-medium">
                                <li>
                                  Dùng cờ lê đi kèm để tháo các ốc giữ lồng giặt
                                  ở phía sau máy.
                                </li>
                                <li>
                                  Lắp các miếng đệm cao su vào vị trí các ốc đã
                                  tháo để tránh côn trùng, bụi bẩn vào bên trong
                                  máy.
                                </li>
                              </ul>
                              <div
                                style={{
                                  width: '491px',
                                  height: '276px',
                                  aspectRatio: '153/86',
                                }}
                              >
                                <img src="" alt="" />
                              </div>
                            </div>
                          ),
                        },
                        {
                          key: '3',
                          label: (
                            <span className="text-title-large py-12 px-8 flex">
                              {t(
                                'Installation Guide for Upper Kitchen Cabinet'
                              )}
                            </span>
                          ),
                          children: (
                            <div
                              className="flex p-16 items-start gap-40 self-stretch"
                              style={{ height: '308px' }}
                            >
                              <ul className="grow text-body-medium">
                                <li>
                                  Dùng cờ lê đi kèm để tháo các ốc giữ lồng giặt
                                  ở phía sau máy.
                                </li>
                                <li>
                                  Lắp các miếng đệm cao su vào vị trí các ốc đã
                                  tháo để tránh côn trùng, bụi bẩn vào bên trong
                                  máy.
                                </li>
                              </ul>
                              <div
                                style={{
                                  width: '491px',
                                  height: '276px',
                                  aspectRatio: '153/86',
                                }}
                              >
                                <img src="" alt="" />
                              </div>
                            </div>
                          ),
                        },
                        {
                          key: '4',
                          label: (
                            <span className="text-title-large py-12 px-8 flex">
                              {t(
                                'Installation Guide for Corner Upper Kitchen Cabinet'
                              )}
                            </span>
                          ),
                          children: (
                            <div
                              className="flex p-16 items-start gap-40 self-stretch"
                              style={{ height: '308px' }}
                            >
                              <ul className="grow text-body-medium">
                                <li>
                                  Dùng cờ lê đi kèm để tháo các ốc giữ lồng giặt
                                  ở phía sau máy.
                                </li>
                                <li>
                                  Lắp các miếng đệm cao su vào vị trí các ốc đã
                                  tháo để tránh côn trùng, bụi bẩn vào bên trong
                                  máy.
                                </li>
                              </ul>
                              <div
                                style={{
                                  width: '491px',
                                  height: '276px',
                                  aspectRatio: '153/86',
                                }}
                              >
                                <img src="" alt="" />
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                </div>
              ),
            },
          ]}
          activeKey={activedKey}
          style={{ height: '100%' }}
          onChange={key => {
            setActivedKey(key);
          }}
        />
      </div>
      <div className="lg:hidden flex py-[32px] px-[16px] gap-[16px] bg-fills-white overflow-hidden self-stretch grow">
        <Collapse
          expandIcon={({ isActive }) => (
            <span className="w-16 h-16 flex">
              {isActive ? (
                <ButtonIconOutlineMedium icon={<Icon.ICExpandMore />} />
              ) : (
                <ButtonIconOutlineMedium icon={<Icon.ICExpandLess />} />
              )}
            </span>
          )}
          expandIconPosition="end"
          defaultActiveKey={['detail']}
          onChange={() => {}}
          className="grow w-full gap-[16px] [&_.ant-collapse-item]:bg-white [&_.ant-collapse-item]:pb-[16px] [&_.ant-collapse-item]:border-transparent [&_.ant-collapse-item]:border-b-[1px] [&_.ant-collapse-item]:border-solid [&_.ant-collapse-item]:border-b-outline-default-primary"
          items={[
            {
              key: 'detail',
              label: (
                <span className="text-title-medium !font-bold">
                  {t('Product details')}
                </span>
              ),
              classNames: {
                body: '!p-0',
                header:
                  '!p-0 h-[32px] [&_.ant-collapse-expand-icon]:!ps-0 [&_.ant-collapse-expand-icon]:!w-[32px] [&_.ant-collapse-expand-icon]:!h-[32px] [&_.ant-collapse-expand-icon.ant-collapse-arrow]:!w-[32px] [&_.ant-collapse-expand-icon.ant-collapse-arrow]:!h-[32px]',
              },
              children: (
                <>
                  <div className="w-full relative flex p-[16px] md:px-[20px] items-start self-stretch grow rounded-[16px] bg-fills-primary-varient">
                    <div className="flex flex-col items-start grow self-stretch overflow-hidden relative gap-[8px]">
                      <div className="flex items-center justify-start self-stretch overflow-x-auto [&::-webkit-scrollbar]:hidden">
                        <Menu
                          className={
                            'flex items-start gap-8 bg-transparent !border-none text-black-medium [&_.ant-menu-item-selected]:bg-primary-primaryFill [&_.ant-menu-item-selected]:text-black-high [&_.ant-menu-item-selected_.ant-menu-title-content_.text-body-medium]:font-semibold [&_.ant-menu-item]:h-[32px] [&_.ant-menu-item]:leading-[32px] [&_.ant-menu-item]:rounded-[4px] [&_.ant-menu-item]:ps-[12px] [&_.ant-menu-item]:pe-[12px] [&_.ant-menu-item]:!w-fit'
                          }
                          onClick={e => {
                            setActiveMenuKey(e.key);
                          }}
                          defaultSelectedKeys={activeMenuKey?.toString()}
                          items={[
                            ...items
                              .map(([key], index) => ({
                                key: index.toString(),
                                label: (
                                  <span className="text-body-medium">
                                    {t(key)}
                                  </span>
                                ),
                              }))
                              .sort(
                                (a, b) =>
                                  !a.name?.localeCompare(b.name, 'vi', {
                                    sensitivity: 'base',
                                  })
                              ),
                          ]}
                        />
                      </div>

                      <div
                        className="flex self-stretch grow bg-white rounded-[8px] overflow-hidden"
                        // style={{ height: "100%", overflow: "auto" }}
                      >
                        <Table
                          dataSource={items
                            .filter(
                              (_, index) => index.toString() === activeMenuKey
                            )
                            .map(([key, value]) => {
                              if (
                                ['countertop', 'backsplash'].some(item =>
                                  key.toLowerCase().includes(item)
                                )
                              ) {
                                const items =
                                  data?.['meta_data']?.price?.[
                                    key.toLowerCase()
                                  ];
                                const temp = value.map((item, index) => ({
                                  ...item,
                                  size: {
                                    x: items?.[index]?.length ?? 0,
                                  },
                                }));
                                return temp;
                              } else return value;
                            })
                            .flat()
                            .reduce((prev, curr) => {
                              const index = prev.findIndex(item => {
                                return (
                                  JSON.stringify({
                                    ...item,
                                    size: {
                                      x: roundTo(item.size?.x ?? 0),
                                      y: roundTo(item.size?.y ?? 0),
                                      z: roundTo(item.size?.z ?? 0),
                                    },
                                    count: 0,
                                  }) ===
                                  JSON.stringify({
                                    ...curr,
                                    size: {
                                      x: roundTo(curr.size?.x ?? 0),
                                      y: roundTo(curr.size?.y ?? 0),
                                      z: roundTo(curr.size?.z ?? 0),
                                    },
                                    count: 0,
                                  })
                                );
                              });
                              if (index >= 0) {
                                const arr = [...prev];
                                arr[index] = {
                                  ...arr[index],
                                  count: arr[index].count + curr.count,
                                };
                                return arr;
                              }
                              return [...prev, curr];
                            }, [])
                            .sort(
                              (a, b) =>
                                !a.name?.localeCompare(b.name, 'vi', {
                                  sensitivity: 'base',
                                })
                            )}
                          showHeader={false}
                          columns={[
                            {
                              title: t('Product'),
                              dataIndex: 'thumbnail_url',
                              key: 'thumbnail_url',
                              width: 104,
                              render: value => {
                                return (
                                  <div className="flex py-[16px] px-[8px] justify-center items-center gap-10 self-stretch">
                                    <img
                                      src={value}
                                      alt=""
                                      className="w-60 h-60 fex-shrink-0 rounded-[2px]"
                                    />
                                  </div>
                                );
                              },
                            },
                            {
                              title: t('Information'),
                              dataIndex: 'info',
                              key: 'info',
                              render: (_, record) => {
                                let result;
                                if (record?.size) {
                                  if (record?.size?.x) {
                                    result = roundTo(
                                      (record?.size?.x ?? 0) * 1000,
                                      0
                                    );
                                  }
                                  if (record?.size?.y) {
                                    if (result) {
                                      result = result + ' x ';
                                    } else {
                                      result = '';
                                    }
                                    result =
                                      result +
                                      roundTo((record?.size?.y ?? 0) * 1000, 0);
                                  }
                                  if (record?.size?.z) {
                                    if (result) {
                                      result = result + ' x ';
                                    } else {
                                      result = '';
                                    }
                                    result =
                                      result +
                                      roundTo((record?.size?.z ?? 0) * 1000, 0);
                                  }
                                }
                                return (
                                  <div className="flex py-[16px] justify-center items-start gap-8 self-stretch grow flex-col">
                                    <span className="text-title-medium">
                                      {t(getValueFromString(record.name))}
                                    </span>
                                    <div className="flex flex-col items-start gap-4 self-stretch">
                                      {record.material ? (
                                        <div className="flex items-start gap-8 self-stretch">
                                          <span
                                            className="text-body-medium"
                                            style={{ color: '#818589' }}
                                          >
                                            {t('Material')}
                                          </span>
                                          <span className="text-body-medium">
                                            {t(record.material)}
                                          </span>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {record.texture || record.paintColor ? (
                                        <div className="flex items-start gap-8 self-stretch">
                                          <span
                                            className="text-body-medium"
                                            style={{ color: '#818589' }}
                                          >
                                            {t('Color')}
                                          </span>
                                          <span className="text-body-medium">
                                            {record.texture ??
                                              record.paintColor ??
                                              '--'}
                                          </span>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      {result && (
                                        <span className="text-body-medium">
                                          {result} mm
                                        </span>
                                      )}
                                      {record?.count && (
                                        <span className="text-body-medium">
                                          x{record.count} mm
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                );
                              },
                            },
                          ]}
                          className="[&_.ant-table-body_tr_td:first-child]:!border-none"
                          pagination={false}
                          scroll={{ y: 640 }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ),
            },
            {
              key: 'warranty',
              label: (
                <span className="text-title-medium !font-bold">
                  {t('Warranty & Maintenance')}
                </span>
              ),
              classNames: {
                body: '!p-0',
                header:
                  '!p-0 h-[32px] [&_.ant-collapse-expand-icon]:!ps-0 [&_.ant-collapse-expand-icon]:!w-[32px] [&_.ant-collapse-expand-icon]:!h-[32px] [&_.ant-collapse-expand-icon.ant-collapse-arrow]:!w-[32px] [&_.ant-collapse-expand-icon.ant-collapse-arrow]:!h-[32px]',
              },
              children: (
                <>
                  <Empty />
                </>
              ),
            },
            {
              key: 'installation',
              label: (
                <span className="text-title-medium !font-bold">
                  {t('Installation Guide')}
                </span>
              ),
              classNames: {
                body: '!p-0',
                header:
                  '!p-0 h-[32px] [&_.ant-collapse-expand-icon]:!ps-0 [&_.ant-collapse-expand-icon]:!w-[32px] [&_.ant-collapse-expand-icon]:!h-[32px] [&_.ant-collapse-expand-icon.ant-collapse-arrow]:!w-[32px] [&_.ant-collapse-expand-icon.ant-collapse-arrow]:!h-[32px]',
              },
              children: (
                <>
                  <div
                    className="flex relative w-full p-[16px] md:px-[20px] flex-col items-end gap-16 grow self-stretch rounded-[8px]"
                    style={{
                      background: '#FAFBFB',
                    }}
                  >
                    <ButtonSecondaryLarge
                      posIcon={<Icon.ICDownload />}
                      title={t('Download full PDF')}
                    />
                    <div className="flex flex-col items-start gap-16 grow self-stretch">
                      <Collapse
                        expandIcon={({ isActive }) => (
                          <span className="w-16 h-16 flex">
                            {isActive ? (
                              <Icon.ICExpandMore />
                            ) : (
                              <Icon.ICExpandLess />
                            )}
                          </span>
                        )}
                        defaultActiveKey={['1']}
                        className="self-stretch overflow-auto"
                        items={[
                          {
                            key: '1',
                            label: (
                              <span className="text-title-large py-12 px-8 flex">
                                {t(
                                  'Installation Guide for Lower Kitchen Cabinet'
                                )}
                              </span>
                            ),
                            classNames: { body: '!p-0' },
                            children: (
                              <div className="grid grid-rows-2 p-16 items-start gap-[16px] self-stretch">
                                <ul className="grow text-body-medium">
                                  <li>
                                    Dùng cờ lê đi kèm để tháo các ốc giữ lồng
                                    giặt ở phía sau máy.
                                  </li>
                                  <li>
                                    Lắp các miếng đệm cao su vào vị trí các ốc
                                    đã tháo để tránh côn trùng, bụi bẩn vào bên
                                    trong máy.
                                  </li>
                                </ul>
                                <div className="aspect-[153/86]">
                                  <img src="" alt="" />
                                </div>
                              </div>
                            ),
                          },
                          {
                            key: '2',
                            label: (
                              <span className="text-title-large py-12 px-8 flex">
                                {t(
                                  'Installation Guide for Corner Lower Kitchen Cabinet'
                                )}
                              </span>
                            ),
                            children: (
                              <div className="grid grid-rows-2 p-16 items-start gap-[16px] self-stretch">
                                <ul className="grow text-body-medium">
                                  <li>
                                    Dùng cờ lê đi kèm để tháo các ốc giữ lồng
                                    giặt ở phía sau máy.
                                  </li>
                                  <li>
                                    Lắp các miếng đệm cao su vào vị trí các ốc
                                    đã tháo để tránh côn trùng, bụi bẩn vào bên
                                    trong máy.
                                  </li>
                                </ul>
                                <div className="aspect-[153/86]">
                                  <img src="" alt="" />
                                </div>
                              </div>
                            ),
                          },
                          {
                            key: '3',
                            label: (
                              <span className="text-title-large py-12 px-8 flex">
                                {t(
                                  'Installation Guide for Upper Kitchen Cabinet'
                                )}
                              </span>
                            ),
                            children: (
                              <div className="grid grid-rows-2 p-16 items-start gap-[16px] self-stretch">
                                <ul className="grow text-body-medium">
                                  <li>
                                    Dùng cờ lê đi kèm để tháo các ốc giữ lồng
                                    giặt ở phía sau máy.
                                  </li>
                                  <li>
                                    Lắp các miếng đệm cao su vào vị trí các ốc
                                    đã tháo để tránh côn trùng, bụi bẩn vào bên
                                    trong máy.
                                  </li>
                                </ul>
                                <div className="aspect-[153/86]">
                                  <img src="" alt="" />
                                </div>
                              </div>
                            ),
                          },
                          {
                            key: '4',
                            label: (
                              <span className="text-title-large py-12 px-8 flex">
                                {t(
                                  'Installation Guide for Corner Upper Kitchen Cabinet'
                                )}
                              </span>
                            ),
                            children: (
                              <div className="grid grid-rows-2 p-16 items-start gap-[16px] self-stretch">
                                <ul className="grow text-body-medium">
                                  <li>
                                    Dùng cờ lê đi kèm để tháo các ốc giữ lồng
                                    giặt ở phía sau máy.
                                  </li>
                                  <li>
                                    Lắp các miếng đệm cao su vào vị trí các ốc
                                    đã tháo để tránh côn trùng, bụi bẩn vào bên
                                    trong máy.
                                  </li>
                                </ul>
                                <div className="aspect-[153/86]">
                                  <img src="" alt="" />
                                </div>
                              </div>
                            ),
                          },
                        ]}
                      />
                    </div>
                  </div>
                </>
              ),
            },
          ]}
        />
      </div>
    </>
  );
};

export default SectionDetail;
